import { Grid, Typography, Box, makeStyles, } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import CountyContext from '../../contexts/CountyContext';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import SubquestionBox from '../SubquestionBox';
import CountyMap from './CountyMap';
import ExposureBySettingType from './ExposureBySettingType';
import ExposureBySubsidyAcceptance from './ExposureBySubsidyAcceptance';
import CountyComparisonTable from './CountyComparisonTable';
import Filters from './Filters';
import ErrorBoundary from '../ErrorBoundary';

function Q1Row3() {
  const [acceptSubsidies, setAcceptSubsidies] = useState('Accept subsidies');
  const [settingType, setSettingType] = useState('All');

  const [county, setCounty] = useState(null);
  const [countyCode, setCountyCode] = useState(null);

  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  return (
    <FiltersContext.Provider value={{
      settingType, setSettingType, acceptSubsidies, setAcceptSubsidies,
    }}
    >
      <CountyContext.Provider value={{
        county, setCounty, countyCode, setCountyCode,
      }}
      >
        <SubquestionBox color={lightColor}>
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >

            <Grid item xs={12}>
              <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
                Child Care Slots in High-Risk Locations By County
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box displayPrint="none">
                <Filters />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box displayPrint="none">
                <Typography variant="h6" align="center" style={{ textTransform: 'none' }} gutterBottom>
                  Click on a county below to see additional data
                </Typography>
              </Box>
              <ErrorBoundary>
                <CountyMap />
              </ErrorBoundary>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Grid container spacing={2}>
                <Grid item xs={12} align="center">
                  <ErrorBoundary>
                    <ExposureBySettingType height={300} measure="capacity:SUM(capacity)" />
                  </ErrorBoundary>
                </Grid>
                <Grid item xs={12} align="center">
                  <ErrorBoundary>
                    <ExposureBySubsidyAcceptance height={300} measure="capacity:SUM(capacity)" />
                  </ErrorBoundary>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div className="pagebreak100" />
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >
            <Grid item xs={12}>
              <ErrorBoundary>
                <CountyComparisonTable />
              </ErrorBoundary>
            </Grid>
          </Grid>

        </SubquestionBox>
      </CountyContext.Provider>
    </FiltersContext.Provider>
  );
}

export default Q1Row3;
